<template>
  <div>
    <div class="conTit" style="margin-top:10px">
      <span></span>
      <p>销售总额+UV</p>
    </div>
    <div class="TianCharts">
      <div class="brandSel">
        <van-dropdown-menu active-color="#CC4545">
          <van-dropdown-item v-model="value" :options="option1" @change="getTianchartsList(value)" />
        </van-dropdown-menu>
      </div>
      <div id="myChart"></div>
      <span class="infoText">*滑动滚动条查看更多数据</span>
    </div>
    <!-- <div class="conTit">
      <span></span>
      <p>单量销售额 : 销售总额 / UV</p>
    </div>
    <div class="TianCharts">
      <div id="rate"></div>
    </div> -->
  </div>
</template>
<script>
import uv from "../../assets/jpg/uv.svg";
import pos from "../../assets/jpg/pos.svg";
import lypos from "../../assets/jpg/LyPos.png";
import lyuv from "../../assets/jpg/LyUv.png";
import qs from "qs";
export default {
  data() {
    return {
      value: "FS Aveeno",
      option1: [],
      ShopList: [],
      tableList: [],
      uvData: [],
      posData: [],
      MyxAxis: [],
      RateMaxRy: 0,
      RateMaxLy: 0,
      lyPos: [],
      lyUv: [],
      rate: [],
      LyRate: [],
      maxRy: 0,
      maxLy: 0
    };
  },
  methods: {
    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById("myChart"));
      // 绘制图表
      myChart.setOption({
        tooltip: {
          trigger: "axis",
          height: 260,
          backgroundColor: " rgba(204, 69, 69,0.8);",
          padding: [5, 15, 5, 15], //边距
          borderColor: "#DDDDDF", //边框颜色
          borderWidth: 1, //边框线宽度
          textStyle: {
            //文字样式
            fontFamily: "PingFangSC-Regular",
            fontSize: "12px",
            color: " #FFFFFF"
          }
        },
        legend: {
          top: "3.5%",
          itemWidth: 16,
          itemHeight: 16,
          data: [
            {
              name: "UV (K)",
              icon: `image://${uv}`
            },
            {
              name: "LY UV (K)",
              icon: `image://${lyuv}`
            },
            {
              name: "POS (`000)",
              icon: `image://${pos}`
            },
            {
              name: "LY POS (`000)",
              icon: `image://${lypos}`
            }
          ],
          // selected: { "LY POS (`000)": false },
          textStyle: {
            color: "#626262",
            fontSize: 10,
            letterSpacing: 0,
            fontFamily: "PingFangSC-Regular"
          }
        },
        grid: [
          {
            show: false
          }
        ],
        dataZoom: [
          {
            xAxisIndex: 0, //这里是从X轴的0刻度开始
            show: true, //是否显示滑动条，不影响使用
            type: "slider", // 这个 dataZoom 组件是 slider 型 dataZoom 组件
            startValue: 15, // 从头开始。
            endValue: 30, // 一次性展示6个。
            height: 20,
            handleSize: 0,
            backgroundColor: "rgba(209,87,87,.7)",
            top: "90%"
          }
        ],
        xAxis: {
          show: true,
          type: "category",
          boundaryGap: true,
          splitLine: { show: false },
          data: this.MyxAxis,
          axisLabel: {
            interval: 0,
            rotate: 40,
            show: true,
            textStyle: {
              fontFamily: "STYuanti-SC-Light",
              fontSize: 10,
              color: "#292929",
              letterSpacing: 0,
              textAlign: "center"
            }
          },
          axisLine: {
            lineStyle: {
              color: "white"
            }
          }
        },
        yAxis: [
          {
            name: ["UV (K)","LY UV (K)"],
            show: true,
            type: "value",
            splitLine: { show: false },
            axisLine: {
              lineStyle: {
                color: "white"
              }
            },
            axisLabel: {
              interval: 0,
              show: true,
              textStyle: {
                fontFamily: "STYuanti-SC-Light",
                fontSize: 10,
                color: "#292929",
                letterSpacing: 0,
                textAlign: "center"
              }
            },
            min: 0,
            boundaryGap: ["0.43", "0.12"],
            axisTick: {}
          },
          {
            name: ["POS (`000)","LY POS (`000)"],
            show: true,
            type: "value",
            splitLine: {
              show: true,
              lineStyle: {
                type: "dashed"
              }
            },
            axisLine: {
              lineStyle: {
                color: "white"
              }
            },
            axisLabel: {
              interval: 0,
              show: true,
              textStyle: {
                fontFamily: "STYuanti-SC-Light",
                fontSize: 10,
                color: "#292929",
                letterSpacing: 0,
                textAlign: "center"
              }
            },
            min: 0
          }
        ],
        series: [
          {
            name: "UV (K)",
            type: "line",
            data: this.uvData,
            yAxisIndex: 0,
            symbolSize: 6,
            itemStyle: {
              normal: {
                color: "#912BD5" //折线颜色
              }
            }
          },
          {
            name: "LY UV (K)",
            type: "line",
            data: this.lyUv,
            yAxisIndex: 0,
            symbolSize: 6,
            itemStyle: {
              normal: {
                color: "#7990B5" //折线颜色
              }
            }
          },
          {
            name: "LY POS (`000)",
            type: "line",
            data: this.lypos,
            yAxisIndex: 1,
            symbolSize: 6,
            itemStyle: {
              normal: {
                color: "#7C945A" //折线颜色
              }
            }
          },
          {
            name: "POS (`000)",
            type: "line",
            data: this.posData,
            yAxisIndex: 1,
            itemStyle: {
              normal: {
                color: "#BFAA47",
                areaStyle: { type: "default" },
                lineStyle: { color: "#BFAA47" }
              }
            },
            areaStyle: {
              // 实现蓝白渐变色
              normal: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#BFAA47"
                  },
                  {
                    offset: 1,
                    color: "#FFFFFF"
                  }
                ])
              }
            }
          }
        ]
      });
    },
    drawLineRate() {
      let myChartRate = this.$echarts.init(document.getElementById("rate"));
      myChartRate.setOption({
        legend: {
          top: "2.5%",
          itemWidth: 16,
          itemHeight: 16,
          data: [
            {
              name: "单量销售额 (RMB)",
              icon: `image://${uv}`
            },
            {
              name: "LY单量销售额 (RMB)",
              icon: `image://${pos}`
            }
          ],
          textStyle: {
            color: "#626262",
            fontSize: 10,
            letterSpacing: 0,
            fontFamily: "PingFangSC-Regular"
          }
        },
        tooltip: {
          trigger: "axis",
          backgroundColor: " rgba(204, 69, 69,0.8);",
          padding: [5, 15, 5, 15], //边距
          borderColor: "#DDDDDF", //边框颜色
          borderWidth: 1, //边框线宽度
          textStyle: {
            //文字样式
            fontFamily: "PingFangSC-Regular",
            fontSize: "12px",
            color: " #FFFFFF"
          }
        },
        grid: [
          {
            show: false
          }
        ],
        dataZoom: [
          {
            xAxisIndex: 0, //这里是从X轴的0刻度开始
            show: true, //是否显示滑动条，不影响使用
            type: "slider", // 这个 dataZoom 组件是 slider 型 dataZoom 组件
            startValue: 0, // 从头开始。
            endValue: 15, // 一次性展示6个。
            height: 20,
            handleSize: 0,
            backgroundColor: "rgba(209,87,87,.7)",
            top: "90%"
          }
        ],
        xAxis: {
          show: true,
          type: "category",
          boundaryGap: true,
          splitLine: {
            show: false
          },
          data: this.MyxAxis,
          axisLabel: {
            interval: 0,
            rotate: 40,
            show: true,
            textStyle: {
              fontFamily: "STYuanti-SC-Light",
              fontSize: 10,
              color: "#292929",
              letterSpacing: 0,
              textAlign: "center"
            }
          },
          axisLine: {
            lineStyle: {
              color: "white"
            }
          }
        },
        yAxis: [
          {
            name: "LY单量销售额 (RMB)",
            type: "value",
            splitLine: {
              show: true,
              lineStyle: {
                type: "dashed"
              }
            },
            axisLine: {
              lineStyle: {
                color: "white"
              }
            },
            axisLabel: {
              interval: 0,
              show: true,
              textStyle: {
                fontFamily: "STYuanti-SC-Light",
                fontSize: 10,
                color: "#292929",
                letterSpacing: 0,
                textAlign: "center"
              }
            },
            max: this.RateMaxRy,
            min: 0,
            boundaryGap: ["0.43", "0.12"],
            axisTick: {}
          }
        ],
        series: [
          {
            name: "单量销售额 (RMB)",
            type: "line",
            data: this.rate,
            yAxisIndex: 0,
            symbolSize: 6,
            itemStyle: {
              normal: {
                color: "#912BD5" //折线颜色
              }
            }
          },
          {
            name: "LY单量销售额 (RMB)",
            type: "line",
            data: this.LyRate,
            yAxisIndex: 0,
            symbolSize: 6,
            itemStyle: {
              normal: {
                color: "#BFAA47" //折线颜色
              }
            }
          }
        ]
      });
    },
    getTianchartsList(value = "FS Aveeno") {
      this.$emit("senDshopNm", this.value);
      this.$addr
        .post(
          `Sales/getTmallShopNmData`,
          qs.stringify({ monthType: 1, shopNm: value })
        )
        .then(res => {
          this.lyUv = [];
          this.uvData = [];
          this.posData = [];
          this.lypos = [];
          this.MyxAxis = [];
          this.rate = [];
          this.LyRate = [];
          this.tableList = res.data.data;
          this.tableList.map((item, index) => {
            // console.log( item.lyUv)
            // console.log( item.lySalesValue)
            // console.log(isNaN(item.lySalesValue / item.lyUv))
            
            this.LyRate.push(isNaN(item.lySalesValue / item.lyUv)?0:(item.lySalesValue / item.lyUv).toFixed(1)-0);
            this.rate.push((item.salesValue / item.uv)==Infinity?0:(item.salesValue / item.uv).toFixed(1)-0);
            // console.log(`${item.salesValue}/${item.uv}=${item.salesValue/item.uv}`)
            // console.log(item.uv)
            this.lyUv.push(item.lyUv);
            this.uvData.push(item.uv);
            this.posData.push(item.salesValue);
            this.MyxAxis.push(item.date);
            this.lypos.push(item.lySalesValue);
          });
          var maxLy = this.uvData.reduce(function(a, b) {
            return b > a ? b : a;
          });
          var maxLyVv = this.lyUv.reduce(function(a, b) {
            return b > a ? b : a;
          });
          var maxRy = this.posData.reduce(function(a, b) {
            return b > a ? b : a;
          });
          var maxRyPos = this.lypos.reduce(function(a, b) {
            return b > a ? b : a;
          });
          var maxRateLy = this.rate.reduce(function(a, b) {
            return b > a ? b : a;
          });
          var maxRateRy = this.LyRate.reduce(function(a, b) {
            return b > a ? b : a;
          });

          this.RateMaxRy = Math.max(maxRateLy,maxRateRy);
          this.maxRy = Math.ceil(Math.max( maxRyPos, maxRy) / 100) * 105;
          this.maxLy = Math.ceil(Math.max( maxLyVv, maxLy) / 100) * 105;

          
          this.drawLine();
          // this.drawLineRate();
        })
        .catch(error => {
          // this.$toast('接受数据失败');
        });
    },
    getShopList() {
      this.$addr
        .post(`Sales/getShopNmList`)
        .then(res => {
          this.ShopList = res.data.data;
          this.ShopList.map((item, index) => {
            this.option1.push(
              Object.assign({}, item, { text: item.shopNm, value: item.shopNm })
            );
          });
          this.option1.unshift({ text: "全部店铺", value: 1 });
        })
        .catch(error => {
          // Toast.fail("加载失败");
        });
    }
  },
  mounted() {
    this.getShopList();
    this.getTianchartsList();
  }
};
</script>
<style scoped>
.TianCharts {
  margin-bottom: 20px;
  position: relative;
}
.infoText{
  position: absolute;
  bottom: 0;
  color: floralwhite;
      position: absolute;
    right: 30%;
    bottom: -10%;
    height: .425532rem;
    min-width: 1.276596rem;
    background: #d1534b;
    z-index: 99;
    padding: .06383rem .170213rem;
    -webkit-box-shadow: 0 0.042553rem 0.212766rem 0 rgba(0,0,0,.5);
    box-shadow: 0 0.042553rem 0.212766rem 0 rgba(0,0,0,.5);
    border-radius: .106383rem;
    font-family: "PingFangSC-Medium";
    font-size: 14px!important;
    text-align: center;
  
}
#myChart {
  background: #fcfcfc;
  border-radius: 15px;
  min-height: 280px;
  margin-bottom: 20px;
}
#rate {
  background: #fcfcfc;
  border-radius: 15px;
  min-height: 280px;
  margin-bottom: 20px;
}
.brandSel {
  position: relative;
}
.van-dropdown-menu {
  position: absolute;
  top: -50px;
  z-index: 5;
  background: #ffffff;
  border: 1px solid #d15757;
  box-shadow: 0 3px 8px 0 rgba(204, 69, 69, 0.3);
  border-radius: 42.5px;
  width: 36.7%;
  height: 21px;
}
.conTit {
  display: flex;
  align-items: center;
  height: 21px;
  width: 100%;
}
.conTit span {
  height: 13px;
  width: 5px;
  display: inline-block;
  background: #ba4d4c;
  border-radius: 3.5px;
  margin-right: 10px;
}
.conTit p {
  line-height: 21px;
  font-weight: bold;
  font-family: "STYuanti-SC-Bold";
  font-size: 16px;
  color: #595b66;
}
/deep/ .van-popup--top {
  width: 36.7%;
  background: rgba(209, 87, 87, 0.9);
  border-radius: 5%;
  left: 2.6%;
  top: 2px;
}
/deep/ .van-overlay {
  background-color: rgba(0, 0, 0, 0);
}
/deep/ .van-cell__value {
  display: none;
}
/deep/ .van-cell__title {
  font-family: "PingFangSC-Regular";
  font-size: 12px;
  color: #ffffff;
}
/deep/ .van-cell {
  background-color: rgba(0, 0, 0, 0);
}
/deep/ .van-ellipsis {
  font-family: "PingFangSC-Medium";
  font-size: 12px;
  color: #cc4545;
}
/deep/ .van-dropdown-menu__title::after {
  border-color: transparent transparent #cc4545 #cc4545;
}
/deep/ .van-dropdown-item__content {
  max-height: 55%;
}
/deep/ .van-dropdown-menu__bar{
  height: 100%;
  background:  none !important;
}
</style>


// WEBPACK FOOTER //
// src/components/TianMao/Tiancharts.vue